import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaCeseActividadParcialByID = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaCeseActividadParcialByID = () => {
  const [loadingGetDeclaracionJuradaCeseActividadParcialByID, setLoadingDeclaracionJuradaCeseActividadParcialByID] = useState(false);
  const [successGetDeclaracionJuradaCeseActividadParcialByID, setSuccessDeclaracionJuradaCeseActividadParcialByID] = useState(false);
  const [errorGetDeclaracionJuradaCeseActividadParcialByID, setErrorDeclaracionJuradaCeseActividadParcialByID] = useState<any>(null);
  const [dataGetDeclaracionJuradaCeseActividadParcialByID, setDataDeclaracionJuradaCeseActividadParcial] = useState<any>(null);

  const [statusGetDeclaracionJuradaCeseActividadParcialByID, setStatusGetDeclaracionJuradaCeseActividadParcialByID] =
    useState<StatusGetDeclaracionJuradaCeseActividadParcialByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaCeseActividadParcialByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingDeclaracionJuradaCeseActividadParcialByID(true);
    setSuccessDeclaracionJuradaCeseActividadParcialByID(false);
    setErrorDeclaracionJuradaCeseActividadParcialByID(null);

    try {
      const res = await apiRecord.getSolicitudDeclaracionJuradaParcialByID(userId, prestacionId, id);

      setStatusGetDeclaracionJuradaCeseActividadParcialByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessDeclaracionJuradaCeseActividadParcialByID(true);
      setDataDeclaracionJuradaCeseActividadParcial(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaCeseActividadParcialByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorDeclaracionJuradaCeseActividadParcialByID(err);
      console.error("Error en getDeclaracionJuradaCeseActividadParcialByID:", err);

      throw err;

    } finally {
      setLoadingDeclaracionJuradaCeseActividadParcialByID(false);
    }
  };

  return {
    getDeclaracionJuradaCeseActividadParcialByID,
    loadingGetDeclaracionJuradaCeseActividadParcialByID,
    successGetDeclaracionJuradaCeseActividadParcialByID,
    errorGetDeclaracionJuradaCeseActividadParcialByID,
    dataGetDeclaracionJuradaCeseActividadParcialByID,
    statusGetDeclaracionJuradaCeseActividadParcialByID
  };
};

export default useGetDeclaracionJuradaCeseActividadParcialByID;
